export function modularizeInsightsResponse(data) {
    const panel = {
        cards: [],
        graphs: {},
    };

    if (data && Array.isArray(data.cards)) {
        panel.cards = data.cards
            .filter((card) => card && card.title && card.icon !== undefined)
            .map((card) => ({
                title: card.title || "",
                value: card.value ?? 0,
                subtitle: card.subtitle || "",
                icon: card.icon || "",
            }));
    }

    if (data && Array.isArray(data.graphs)) {
        data.graphs
            .filter((graph) => graph && graph.title)
            .forEach((graph) => {
                const key = graph.title.replace(/\s+/g, '');
                panel.graphs[key] = {
                    title: graph.title || "",
                    xLabel: graph.x_label || "",
                    yLabel: graph.y_label || "",
                    datapoints: Array.isArray(graph.datapoints)
                        ? graph.datapoints
                            .filter((dp) => dp && dp.x && typeof dp.y === "number")
                            .map((dp) => {
                                const date = new Date(dp.x);
                                const isValidDate = !isNaN(date.getTime()) && isNaN(Number(dp.x)) === true;
                                return {
                                    value: !isValidDate
                                        ? dp.x.toLowerCase()
                                        : date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }), // formatted as '11 May'
                                    count: dp.y,
                                };
                            })
                        : [],
                };
            });
    }

    return panel;
}

export function modularizeCategoriesResponse(data) {
    const categoryOptions = [];
    const subcategoryMap = {};
    const modelMap = {};

    for (const categoryId in data) {
        const category = data[categoryId];
        const categoryName = category.name;

        categoryOptions.push({
            value: categoryId,
            label: categoryName,
        });

        const subcategories = category.subcat || {};
        const subOptions = [];

        for (const subId in subcategories) {
            const sub = subcategories[subId];
            subOptions.push({
                value: subId,
                label: sub.name,
            });

            if (sub.models) {
                const modelOptions = [];
                for (const modelId in sub.models) {
                    const model = sub.models[modelId];
                    modelOptions.push({
                        value: modelId,
                        label: model.name,
                    });
                }
                modelMap[subId] = modelOptions;
            }
        }
        subcategoryMap[categoryId] = subOptions;
    }

    return {
        categoryOptions,
        subcategoryMap,
        modelMap,
    };
}